import { registerDecorator, ValidationArguments, ValidationOptions } from "class-validator";

export function IsNotEmptyString(
	validationOptions?: ValidationOptions,
): (object: Object, propertyName: string) => void {
	return (object: Object, propertyName: string): void => {
		registerDecorator({
			name: "isNotEmptyString",
			target: object.constructor,
			propertyName,
			constraints: [],
			options: validationOptions,
			validator: {
				validate(value: any, args: ValidationArguments): boolean {
					// Reject null | undefined | ""
					if (!args.value) {
						return false;
					}

					// Reject if not a string
					if (!(typeof args.value === "string" || args.value instanceof String)) {
						return false;
					}

					return args.value.trim() !== "";
				},

				defaultMessage(args: ValidationArguments): string {
					return `${args.targetName} should not be an empty string`;
				},
			},
		});
	};
}
